import { render } from "./UserPermission.vue?vue&type=template&id=6587eb9e"
import script from "./UserPermission.vue?vue&type=script&lang=js"
export * from "./UserPermission.vue?vue&type=script&lang=js"

import "./UserPermission.vue?vue&type=style&index=0&id=6587eb9e&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__